import { styled } from '@linaria/react';
import { layout, semantic, size, space } from '../../theme/tokens';

export const GridSkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${size.radius['radius-md']};
  overflow: hidden;
  background: ${semantic.bg.canvas};
`;

export const GridSkeletonImage = styled.div<{
  $aspectRatio?: string;
  $mobileAspectRatio?: string;
}>`
  width: 100%;
  aspect-ratio: ${({ $mobileAspectRatio }) => $mobileAspectRatio ?? '6 / 4'};
  border-radius: ${size.radius['radius-md']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio ?? '1 / 1'};
  }

  background: linear-gradient(
    90deg,
    ${semantic.bg.surfaceSubtle} 0px,
    ${semantic.bg.surfaceDefault} 200px,
    ${semantic.bg.surfaceSubtle} 400px
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

export const GridSkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  padding: ${space['space-400']} 0 0;
`;

export const SkeletonLine = styled.div<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '14px'};
  border-radius: ${size.radius['radius-xs']};
  background: linear-gradient(
    90deg,
    ${semantic.bg.surfaceSubtle} 0px,
    ${semantic.bg.surfaceDefault} 200px,
    ${semantic.bg.surfaceSubtle} 400px
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

export const ListSkeletonCard = styled.div`
  display: flex;
  gap: ${space['space-600']};
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding-bottom: ${space['space-600']};
`;

export const ListSkeletonImage = styled.div`
  width: 240px;
  height: 160px;
  flex-shrink: 0;
  border-radius: ${size.radius['radius-md']};
  background: linear-gradient(
    90deg,
    ${semantic.bg.surfaceSubtle} 0px,
    ${semantic.bg.surfaceDefault} 200px,
    ${semantic.bg.surfaceSubtle} 400px
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }

  @media (max-width: ${layout.desktopBreakpoint}) {
    width: 120px;
    height: 100px;
  }
`;

export const ListSkeletonContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${space['space-200']};
  min-width: 0;
`;

export const ListSkeletonFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${space['space-300']};
`;

export const SkeletonRow = styled.div`
  display: flex;
  gap: ${space['space-400']};
  overflow: hidden;
  margin-top: ${space['space-400']};

  & > * {
    flex: 1;
    min-width: 0;
  }
`;
